import { Box } from '@mui/material';

import { ConnectionType, Technology } from 'modules/chains/constants';

import { CodeSnippet } from '../CodeSnippet';
import { languagesMap } from './const';
import { useStyles } from './SnippetsStyles';

export interface SnippetsProps {
  technology: Technology;
  hasFullWidthSnippets?: boolean;
  httpCode: string;
  wssCode?: string;
}

export const Snippets = ({
  hasFullWidthSnippets,
  httpCode,
  technology,
  wssCode,
}: SnippetsProps) => {
  const { classes, cx } = useStyles();

  const language = languagesMap[technology];

  return (
    <Box
      className={cx(classes.snippets, {
        [classes.snippetsFullWidth]: hasFullWidthSnippets,
      })}
    >
      <CodeSnippet
        code={httpCode}
        language={language}
        type={ConnectionType.HTTP}
      />
      {wssCode && (
        <CodeSnippet
          code={wssCode}
          language={language}
          type={ConnectionType.WSS}
        />
      )}
    </Box>
  );
};
